import type { HttpTypes } from "@medusajs/types"

export const VTO_READY_METADATA_KEY = "vto_ready"

type VariantWithMetadata = Pick<HttpTypes.StoreProductVariant, "metadata">

export function isVtoReadyVariant(
  variant: VariantWithMetadata | null | undefined
): boolean {
  return variant?.metadata?.[VTO_READY_METADATA_KEY] === true
}

export function getVtoReadyVariantIds(
  variants: Array<Pick<HttpTypes.StoreProductVariant, "id" | "metadata">> = []
): string[] {
  return variants.filter(isVtoReadyVariant).map((variant) => variant.id)
}
